import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=49de947c&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=49de947c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49de947c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49de947c')) {
      api.createRecord('49de947c', component.options)
    } else {
      api.reload('49de947c', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=49de947c&scoped=true&", function () {
      api.rerender('49de947c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/auction_album_weChat/attribute.vue"
export default component.exports